import type { Participant } from '@seen/core/models/patients/participant'
import { useAstranaAuthorizationSearch } from '#src/hooks/useAstranaAuthorizationSearch.ts'

export function useAstranaSearch(
  participant: Participant
): (() => void) | null {
  const {
    handleSearch,
    hasValidMemberSearch,
    hasValidAuthSearch,
    extensionDetected,
  } = useAstranaAuthorizationSearch(participant)

  if (!extensionDetected || (!hasValidMemberSearch && !hasValidAuthSearch)) {
    return null
  }

  return handleSearch
}
